import Phaser from 'phaser'

export const LOOK_AHEAD_IN_TITLE = 325
export const LOOK_AHEAD = 125
export const LOOK_AHEAD_OFFSET = 1000

const LOOK_FWD_INTERP = 0.0035
const LOOK_NRML_INTERP = 0.015
const LOOK_FROM_TITLE_INTERP = 0.0015

export default class CameraController {
  constructor (scene, player) {
    this.scene = scene
    this.player = player
    this.cam = this.scene.cameras.main

    this.x = 0
    this.y = 0

    this.interpFromTitle = true

    this.isAtScanningRange = false
    this.normalOffset = LOOK_AHEAD_IN_TITLE
    this.targetOffset = this.normalOffset
    this.offset = this.normalOffset
    this.player.once('has-moved', () => {
      this.normalOffset = LOOK_AHEAD
      this.targetOffset = LOOK_AHEAD
    })
  }

  update (time, delta) {
    var targetY = this.player.y
    this.y = this.y + ((targetY - this.y) * (delta * 0.01))

    var interpSpeed = LOOK_NRML_INTERP
    if (this.interpFromTitle) {
      interpSpeed = LOOK_FROM_TITLE_INTERP
    } else if (this.targetOffset > this.offset) {
      interpSpeed = LOOK_FWD_INTERP
    }
    this.isAtScanningRange = Math.abs(LOOK_AHEAD_OFFSET - this.offset) < 15

    this.offset = this.offset + (this.targetOffset - this.offset) * (delta * interpSpeed)
    this.cam.setScroll(this.x - this.cam.width / 2, this.y - this.cam.height / 2 - this.offset)
    this.cam.setZoom(1 - (this.offset / LOOK_AHEAD_OFFSET) * 0.2)

    if (!this.isLookingAhead()) {
      this.normalOffset = Phaser.Math.Linear(LOOK_AHEAD_IN_TITLE, LOOK_AHEAD, Phaser.Math.Clamp(this.player.score / 300, 0, 1))
      this.targetOffset = this.normalOffset
    }
  }

  lookAhead () {
    if (this.targetOffset !== LOOK_AHEAD_OFFSET) {
      this.player.emit('looking')
    }
    this.targetOffset = LOOK_AHEAD_OFFSET
    this.interpFromTitle = false
  }

  lookAtPlayer () {
    this.targetOffset = this.normalOffset
  }

  isLookingAhead () {
    return this.targetOffset === LOOK_AHEAD_OFFSET
  }
}
